import type { Order } from "../../domain/entities/Order";
import type { OrderId } from "../../domain/value-objects/OrderId";
import type { OrderQueryPort } from "../ports/OrderQueryPort";

export class GetOrderByIdUseCase {
  constructor(private readonly orderQueryPort: OrderQueryPort) {}

  async execute(orderId: OrderId): Promise<Order> {
    return this.orderQueryPort.getById(orderId);
  }
}
